export default "__VITE_ASSET__ON7B4G5j__"